import { render } from "./InfoScheme.vue?vue&type=template&id=7d4d8016&scoped=true&ts=true"
import script from "./InfoScheme.vue?vue&type=script&lang=ts"
export * from "./InfoScheme.vue?vue&type=script&lang=ts"

import "./InfoScheme.vue?vue&type=style&index=0&id=7d4d8016&scoped=true&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\170657b851b0ad53\\Loading\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d4d8016"]])

export default __exports__